import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EditDialogComponent } from '../dialogs/edit-dialog/edit-dialog.component';
import { ShiftDirection, ShowCaseDetail, ShowcaseDetailProduct } from 'src/app/api/models/showcases-dto';
import { SharedService } from 'src/app/services/shared.service';
import { AllocationService } from 'src/app/api/services';
import { TranslateService } from '@ngx-translate/core';
import { TraysService } from 'src/app/api/services/trays.service';
import { RoleEnum } from 'src/app/enums/role-enum';

@Component({
  selector: 'app-showcase-detail',
  templateUrl: './showcase-detail.component.html',
  styleUrls: ['./showcase-detail.component.scss']
})
export class ShowcaseDetailComponent {

  private flagPictureOrMap: boolean = true;
  private detail?: ShowCaseDetail;
  private oldProductsOrder: string[] = [];
  private showControlsIndex?: number;
  protected loading: boolean = false;
  protected pictureFile!: File;
  private alreadyShowedModal: boolean = false;

  protected picture: string = "";
  private oldPicture: string = "";

  readonly ACCEPT_FILE = 'image/png, image/gif, image/jpeg';

  constructor(
    public dialogRef: MatDialogRef<EditDialogComponent>,
    public sharedService: SharedService,
    public translateService: TranslateService,
    public allocationService: AllocationService,
    public traysService: TraysService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.loadDetail(this.data.showcaseId)
  }

  loadDetail(showcaseId: number) {
    this.loading = true;
    this.allocationService.getShowcaseDetail(this.data.eventId, showcaseId)
      .subscribe(res => {
        this.detail = res;
        this.picture = res.image;
        this.oldProductsOrder = this.getSapCodes();
        this.oldPicture = res.image;
        this.loading = false;
      },
        err => {
          this.closeDialog();
          this.openSnackBar('loading_error', true);
          this.loading = false;
          console.log(err);
        })
  }

  setActiveTab(flag: boolean) {
    this.flagPictureOrMap = flag;
  }

  isActivePictureTab() {
    return this.flagPictureOrMap;
  }

  isActiveMapTab() {
    return !this.flagPictureOrMap;
  }

  getProducts() {
    if (this.detail) {
      return this.detail.products;
    }
    return [];
  }

  getSapCodes(products: ShowcaseDetailProduct[] | undefined = this.detail?.products) {
    return products?.map(p => p.sapCode) || [];
  }

  getDescription() {
    if (this.detail) {
      return this.detail.showcaseDescription;
    }
    return "";
  }

  getShowcaseCode() {
    if (this.detail) {
      return this.detail.showcaseCode;
    }
    return "";
  }

  getShowcaseFloorCode() {
    if (this.detail) {
      return this.detail.showcaseFloorCode;
    }
    return "";
  }

  shift(direction: ShiftDirection, index: number) {
    if (this.detail) {
      let { products } = this.detail;
      let product = products[index];
      products.splice(index, 1);
      products.splice(index + direction, 0, product);
      this.setShowControlsIndex(index + direction);
      this.detail.products = products;
      //Se c'è un immagine associata alla vetrina allora mostro la modale di alert
      if (this.picture && !this.pictureFile && !this.alreadyShowedModal) {
        this.alreadyShowedModal = true;
        this.traysService.showShowcasePictureDialog$.next(true);
      }
      // this.picture = "";
    }

  }

  getShowControls(index: number) {
    if (this.detail?.products && this.detail?.products.length > 1) {
      return this.showControlsIndex === index;
    } else {
      return false;
    }
  }

  setShowControlsIndex(index: number) {
    if (index !== -1) {
      if (this.showControlsIndex === index) {
        this.showControlsIndex = -1;
      } else {
        this.showControlsIndex = index;
      }
    } else {
      this.showControlsIndex = -1;
    }
  }

  onFileDropped(files: any): void {
    if (files && "0" in files && this.ACCEPT_FILE.includes(files[0].type)) {
      let picture = files[0];
      this.setPicture(picture);
      // this.updateShowcasePicture(files[0]);
    }
  }

  fileBrowseHandler($event: any) {
    let files = $event.target.files;
    if (files && "0" in files) {
      let picture = files["0"];
      this.setPicture(picture);
      // this.updateShowcasePicture(files["0"]);
    }
  }

  setPicture(file: any) {
    this.loading = true;
    this.sharedService.toBase64(file)
      .then((res: any) => {
        this.pictureFile = file;
        this.picture = res;
        this.loading = false;
      })
      .catch((err: any) => {

        this.loading = false;
      })
  }

  handleEditClick() {
    this.picture = "";
  }

  updateShowcasePicture(file: any, callback: Function) {
    this.loading = true;
    this.allocationService.updateShowcaseImage(this.data.eventId, this.data.showcaseId, file).subscribe(res => {
      if (callback) {
        callback()
      }
      this.openSnackBar("uploading_picture_success");
      this.loading = false;
    },
      err => {
        console.log(err);
        this.loading = false;
        this.openSnackBar("uploading_picture_error", true);
      })
  }

  getBackgroundImage() {
    let style: any = {};
    if (this.isActivePictureTab() && this.picture) {
      style.backgroundImage = 'url(' + this.picture + ')';
      style.backgroundPosition = 'center';
      style.backgroundRepeat = 'no-repeat';
      style.backgroundSize = 'contain';
    }
    return style;
  }

  openSnackBar(code?: string, error?: boolean) {
    let translation = "ERROR_GENERIC_RETRY";
    switch (code) {
      case 'loading_success': {
        translation = "PAGES.ALLOCATION.DIALOG.SUCCESS.0";
        break;
      }
      case 'loading_error': {
        translation = "PAGES.ALLOCATION.DIALOG.ERROR.0";
        break;
      }
      case 'updating_order_success': {
        translation = "PAGES.ALLOCATION.DIALOG.SUCCESS.1";
        break;
      }
      case 'updating_order_error': {
        translation = "PAGES.ALLOCATION.DIALOG.ERROR.1";
        break;
      }
      case 'uploading_picture_success': {
        translation = "PAGES.ALLOCATION.DIALOG.SUCCESS.2"
        break;
      }
      case 'uploading_picture_error': {
        translation = "PAGES.ALLOCATION.DIALOG.ERROR.2"
        break;
      }
    }
    this.sharedService.openSnackBar(this.translateService.instant(translation), error || false);
  }

  cancel() {
    this.closeDialog()
  }

  save() {
    if (this.isOrderChanged()) {
      this.loading = true;
      this.allocationService.updateShowcaseProductOrder(this.data.eventId, this.data.showcaseId, this.getSapCodes())
        .subscribe((res) => {
          this.openSnackBar('updating_order_success');
          if (this.pictureFile) {
            this.updateShowcasePicture(this.pictureFile, () => this.closeDialog(true));
          } else {
            this.closeDialog(true);
            this.loading = false;
          }
        },
          (err) => {
            this.loading = false;
            this.openSnackBar('updating_order_error', true);
            console.log(err);
          });
    } else if (this.pictureFile) {
      this.updateShowcasePicture(this.pictureFile, () => this.closeDialog(true));
    }
  }

  closeDialog(edited?: boolean) {
    if (this.oldPicture !== this.picture) {
      edited = true;
    }
    this.dialogRef.close(edited);
  }

  isOrderChanged() {
    return this.oldProductsOrder.toString() !== this.getSapCodes().toString()
  }

  isDisabledSave() {
    return !this.isOrderChanged() && !this.pictureFile
  }

  isReadOnlyView() {
    return this.sharedService.isUserRole(RoleEnum.LOGISTIC_READONLY)
  }

}
